export default __webpack_public_path__ + "static/media/mag6.b65a3b03.png";